var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.07 512.07",
    height: 512,
    viewBox: "0 0 512.07 512.07",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.035 320.004c-8.837 0-16-7.164-16-16v-112c0-8.836 7.163-16 16-16s16 7.164 16 16v112c0 8.837-7.163 16-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.296 400.334-199.19-331.98c-22.6-37.681-77.496-37.754-100.14 0l-199.191 331.98c-18.837 31.395 3.826 71.67 40.58 71.67h417.36c36.76 0 59.414-40.28 40.581-71.67zm-40.581 39.67h-417.359c-11.922 0-19.232-13.07-13.14-23.21l199.19-331.98c10.219-17.033 35.028-17.053 45.26 0l199.19 331.98c6.085 10.129-1.208 23.21-13.141 23.21z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.035,
    cy: 360.004,
    r: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b47190ba1d522822a4dc45402d5c677f.svg";
export { ForwardRef as ReactComponent };